import type { FormatterFactory } from '../types';

export interface GetTextOptions {
  context?: string;
  conversion?: string | string[];
  [option: string]: any;
}

export const gettext: FormatterFactory = (options: GetTextOptions = {}) => ({
  toText: (value) => {
    if (value == null) {
      return '';
    }
    const translate = (globalThis as any).$translate;
    if (!translate) {
      return String(value);
    }
    return translate.translate({ msgid: value, ...options });
  },
});
